var socketFunctions = {
    getNotificationsByUserId: function ($data) {
        socket.emit("getNotificationsByUserId", $data);
    },
    /*
    * Inbox
    * */
    inbox_open_chat_room_by_id: function ($data) {
        socket.emit("myInboxOpenChatRoomById", $data);
    },
    inbox_refresh_room:function ($data) {
        socket.emit("myInboxRefreshRoom", $data);
    },
    inbox_update_room:function ($data) {
        socket.emit("myInboxUpdateRoom", $data);
    },
    inbox_refresh_top_room:function($data){
        socket.emit("myInboxRefreshTopRoom", $data);
    },
    inbox_refresh_list:function ($data) {
        socket.emit("myInboxRefreshList", $data);
    },
};
$(document).ready(function() {
    socket.on('connect', function(){
        socket.emit("newUserConnection", {
            user_id:libs.memoryGet('user_id'),
            real_time_api_token:libs.memoryGet('real_time_api_token')
        });
        socket.on('connectionAllowed', function($obj){
            //First Connection
            socketFunctions.getNotificationsByUserId($obj);
        });
        /*
        * Notifications
        * */
        var $notificationsBinding;
        socket.on('notifications', function($notification){
            try{
                clearTimeout($notificationsBinding);
            }catch ($e){

            }
            $notificationsBinding = setTimeout(function(){
                var $needToView = libs.memoryGet('needToView') ? libs.memoryGet('needToView') : -1;
                var $newNotificationsIndex =  $notification.listen - $notification.viewed;
                if($newNotificationsIndex != $needToView){
                    libs.memorySave('needToView', $newNotificationsIndex);
                    nurseslounge_myDashboard_accountSettings.notificationUpdate($notification);
                }
            }, 800);
        });
        var $inboxNotificationsBinding;
        socket.on('inboxNotifications', function($notification){
            try{
                clearTimeout($inboxNotificationsBinding);
            }catch ($e){

            }
            $inboxNotificationsBinding = setTimeout(function(){
                var $needToViewInboxNotifications = libs.memoryGet('needToViewInboxNotifications') ? libs.memoryGet('needToViewInboxNotifications') : -1;
                var $newInboxNotificationsIndex =  $notification.listen - $notification.viewed;
                if($newInboxNotificationsIndex != $needToViewInboxNotifications){
                    libs.memorySave('needToViewInboxNotifications', $newInboxNotificationsIndex);
                    nurseslounge_myDashboard_accountSettings.inboxNotificationUpdate($notification);
                }
            }, 800);
        });
        /*
        * Inbox
        * */
        socket.on('myInboxOpenChatRoomByIdAnswer', function($data){
            nurseslounge_myDashboard_myInbox.inbox_open_chat_room_by_id_answer($data);
        });
        socket.on('myInboxRefreshRoomAnswer', function(){
            nurseslounge_myDashboard_myInbox.inbox_refresh_room_answer();
        });
        socket.on('myInboxUpdateRoomAnswer', function($data){
            nurseslounge_myDashboard_myInbox.inbox_update_room_answer($data);
        });
        socket.on('myInboxRefreshListAnswers', function($data){
            nurseslounge_myDashboard_myInbox.inbox_refresh_list_answers($data);
        });
        /*
        * Disconnect
        * */
        socket.on('disconnect', function(){
            //window.location = '/logout';
        });
    });
});
